module.exports = __webpack_public_path__ + "static/media/0007.5cb171b2.jpg";